/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import {
	PanelBody,
	TextControl,
	ToggleControl,
	Button,
} from '@wordpress/components';
import { Fragment, useState } from '@wordpress/element';
import { OptionsModal } from '../form-select/modal';

function Settings( props ) {
	const { attributes, setAttributes } = props;
	const { type, name, hidden, required, multiple } = attributes;
	const [ isModalOpen, setModalOpen ] = useState( false );

	return (
		<>
			{ 'hidden' !== type && (
				<InspectorControls>
					<PanelBody title={ __( 'Settings' ) }>
						<TextControl
							autoComplete="off"
							label={ __( 'Name' ) }
							value={ name }
							onChange={ ( newVal ) => {
								setAttributes( {
									name: newVal,
								} );
							} }
							help={ __(
								'Affects the "name" attribute of the input element, and is used as a name for the form submission results.'
							) }
							__next40pxDefaultSize
							__nextHasNoMarginBottom
						/>
						{ 'popper/form-multichoices' !== props.name &&
							'checkbox' !== type && (
								<ToggleControl
									label={ __( 'Hide label' ) }
									checked={ hidden }
									onChange={ ( newVal ) => {
										setAttributes( {
											hidden: newVal,
										} );
									} }
									__nextHasNoMarginBottom
								/>
							) }
						<ToggleControl
							label={ __( 'Required' ) }
							checked={ required }
							onChange={ ( newVal ) => {
								setAttributes( {
									required: newVal,
								} );
							} }
							__nextHasNoMarginBottom
						/>
						{ ( 'popper/form-select' === props.name ||
							( 'popper/form-multichoices' === props.name &&
								'checkbox' === type ) ) && (
							<ToggleControl
								label={ __( 'Multiple', 'popper' ) }
								checked={ multiple }
								onChange={ ( val ) => {
									setAttributes( {
										multiple: val,
									} );
								} }
							/>
						) }
						{ ( 'popper/form-select' === props.name ||
							'popper/form-multichoices' === props.name ) && (
							<Button
								variant="primary"
								onClick={ () => setModalOpen( true ) }
							>
								{ __( 'Manage options', 'popper' ) }
							</Button>
						) }
					</PanelBody>
					{ isModalOpen && (
						<OptionsModal
							{ ...props }
							onRequestClose={ () => {
								setModalOpen( false );
							} }
						/>
					) }
				</InspectorControls>
			) }
		</>
	);
}

export default Settings;
